import styled from "@emotion/styled";

export const APIErrorCustomBannerWrapper = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	marginTop: 0,
	height: "calc(100vh - 230px)",
	minHeight: "460px",
	width: "auto",
	display: "flex",
	flexDirection: "column",
	justifyContent: "center",
	alignItems: "center",
	h5: {
		margin: "24px 0 0 0"
	},
	p: {
		...theme.project.typography.body.body1,
		margin: 0,
		paddingTop: "12px",
		maxWidth: "455px",
		textAlign: "center"
	},
	[theme.breakpoints.down("lg")]: {
		height: "calc(100vh - 245px)"
	}
}));
